<template>
	<div class="wf-component wf-tab-buttons">
		<div class="wf-item tab-search" :class="{active: currentTab == 'search'}" data-translation-element="search" v-touch:tap="switchTab('search')"></div>
	</div>
</template>

<script>
/* global WayfinderAPI wayfinder */
import { mapState } from 'vuex';

export default {
	name: 'Tabs',
	computed: {
		...mapState('wf', ['currentTab', 'searchVisible', 'mobile', 'landscape', 'shortcuts', 'language'])
	},
	data () {
		return {
			toilet: false,
			toiletsIcon: false
		}
	},
	methods: {
		switchTab (tab) {
			return () => {
				this.$emit('switchTab', tab);
			}
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
	.tab-search {
		background-image: url("data:image/svg+xml,%3Csvg width='38' height='38' viewBox='0 0 38 38' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12.4163 24.9709C19.2339 24.9709 24.7607 19.4431 24.7607 12.624C24.7607 5.80493 19.2339 0.276855 12.4163 0.276855C5.59863 0.276855 0.0717773 5.80493 0.0717773 12.624C0.0717773 19.4431 5.59863 24.9709 12.4163 24.9709ZM12.4163 22.5017C17.8706 22.5017 22.292 18.0793 22.292 12.624C22.292 7.1687 17.8706 2.74634 12.4163 2.74634C6.96216 2.74634 2.54077 7.1687 2.54077 12.624C2.54077 18.0793 6.96216 22.5017 12.4163 22.5017Z' fill='url(%23paint0_linear)'/%3E%3Cpath d='M19.8228 23.5245L23.3143 20.0322L35.5347 32.2551C36.4989 33.2195 36.4989 34.7831 35.5347 35.7474C34.5706 36.7118 33.0073 36.7118 32.0432 35.7474L19.8228 23.5245Z' fill='url(%23paint1_linear)'/%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear' x1='12.4163' y1='0.276855' x2='12.4163' y2='24.971' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23D67FFE'/%3E%3Cstop offset='1' stop-color='%23AC92F7'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear' x1='21.5685' y1='21.7783' x2='35.5376' y2='35.7445' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23D67FFE'/%3E%3Cstop offset='1' stop-color='%23AC92F7'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E%0A");
	}

</style>
